import { useHistory } from 'react-router-dom';
import BusinessIcon from '@mui/icons-material/Business';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NavCard from '../EpicAdministration/components/NavCard';

const Navigation = () => {
    const history = useHistory();

    return (
		<>
			<Typography
				variant='h6'
				color='primary'
				align='center'
				gutterBottom
			>
				EpicCare Link Administrative Tools
			</Typography>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'wrap',
					justifyContent: 'space-evenly',
					alignItems: 'stretch',
				}}
			>
				<NavCard
					title={'Site'}
					icon={<BusinessIcon color='error' />}
					description={
						'Associate a sponsor with a new site that failed to automate.'
					}
					navigation={
						<>
							<Button
								size='small'
								onClick={() => history.push('./SiteSponsor')}
								id={'navigation__button--sponsor'}
							>
								Sponsor Association
							</Button>
						</>
					}
				/>
			</Box>
		</>
	);
};

export default Navigation;
